<template lang="html">
  <div class="record-details-container" @click="close">
    <RecordCut
      v-if="recordCutEnabled"
      :record="record"
      :processing="cutProcessing"
      @cut-started="showCutSpinner"
      @cancel="recordCutEnabled = false"
    />
    <a
      href="#" class="close close-detail-video" style="position: absolute; top: 10px; right: 40px;"
      @click.stop.prevent="close"
    >x</a>
    <v-item-group>
    <v-container grid-list-md @click.stop >
      <h2 class="align-center" v-if="record.title && $root.$children[0].$data.clientId != 'digiteka'">{{ record.title }}</h2>
      <h2 v-else="record.description" v-if="record.description && $root.$children[0].$data.clientId != 'digiteka'">{{ record.description }}</h2>

      <h2 ref="testRef" class="align-center record-detail-title" v-if="record.title && $root.$children[0].$data.clientId === 'digiteka'">{{ record.title }}
        <span v-else="record.description" v-if="record.description"> ({{ record.description }})</span>
      </h2>

      <v-layout>
        <v-flex xs="12" md="12">
          <v-item>
          <div v-if="record.record_type === 'VIDEO'">
            <record-player ref="playerComponent" :options="getRecordPlayerOptions(record)"/>
            <v-btn
              v-if="!(record.mldata.approved || record.mldata.deleted_at || cutCacheUpdateLock) && $root.$children[0].$data.clientId != 'digiteka'"
              class="btn btn-primary" flat
              @click="showRecordCut()"
            >
              <template v-if="cutProcessing">
                <span>Cutting</span>
                <span class="loading-indicator"></span>
              </template>
              <span v-else>Cut</span>
            </v-btn>
            <v-btn v-if="$root.$children[0].$data.clientId != 'digiteka'"
              class="btn btn-primary"
              @click.stop.prevent="close"
            >{{ $t('cancel') }}</v-btn>
          </div>
          <div v-else-if="record.record_type === 'IMAGE'">
            <a :href="record.play_link" target="_blank">
              <img :src="record.thumbnail_link">
            </a>
          </div>
          </v-item>
        </v-flex>
        <v-flex xs="12" md="4" v-if="$root.$children[0].$data.clientId != 'digiteka'">
          <ul>
            <li v-if="record.title"><span class="record-attribute">{{ $t('detail_video.title').toUpperCase() }}</span>{{ record.title }}</li>
            <li v-if="record.description"><span class="record-attribute">{{ $t('detail_video.description').toUpperCase() }}</span>{{ record.description }}</li>
            <li><span class="record-attribute">{{ $t('detail_video.user').toUpperCase() }}</span>{{ record.user_full_name }}</li>
            <li v-if="record.contact_phone"><span class="record-attribute">Contact phone</span><a :href="'tel:'+record.contact_phone">{{ record.contact_phone }}</a></li>
            <li v-if="record.email"><span class="record-attribute">Email</span><a :href="'email:'+record.email">{{ record.email }}</a></li>
            <li><span class="record-attribute">{{ $t('detail_video.user_group').toUpperCase() }}</span>
              <span class="user-group tag" v-for="group in record.groups">{{ group.group_name }}</span>
            </li>
            <li><span class="record-attribute">{{ $t('detail_video.date').toUpperCase() }}</span>{{ recordDate }}</li>
            <li><span class="record-attribute">{{ $t('detail_video.time').toUpperCase() }}</span>{{ recordTime }} {{ recordTz }}</li>
            <li><span class="record-attribute">{{ $t('detail_video.gps').toUpperCase() }}</span>{{ recordCoordinates }}</li>
            <li v-if="vod"><span class="record-attribute">{{ $t('detail_video.duration').toUpperCase() }}</span>{{ vod.duration | round}}s</li>
            <li><span class="record-attribute">{{ $t('detail_video.device').toUpperCase() }}</span>{{ record.device.mobile_type }} {{ record.device.os_version }}</li>
            <li v-if="vod"><span class="record-attribute">{{ $t('detail_video.resolution').toUpperCase() }}</span> {{ vod.width }} x {{ vod.height }}</li>
            <li v-if="vod"><span class="record-attribute">{{ $t('detail_video.size').toUpperCase() }}</span>{{ vod.size | filesize }}{{ $t('MB') }}</li>
            <li><span class="record-attribute">{{ $t('detail_video.full_address').toUpperCase() }}</span>{{ record.vod_full_address }} </li>
            <li v-if="record.comment"><span class="record-attribute">{{ $t('detail_video.comment').toUpperCase() }}</span>{{ record.comment }}</li>
            <li v-if="isLmrConsumer">
              <span class="record-attribute">{{ $t('detail_video.category').toUpperCase() }}</span>{{ record.lmr_category }}
            </li>
            <li>&nbsp;</li>
            <li style="display:flex; justify-content:flex-start; align-items:center">
              <span class="record-attribute" style="flex: 0 0 200px;">{{ $t('detail_video.detected_tags').toUpperCase() }}</span>
              <div v-if="!editTagsActive" style="display: inline-block;">
                <span v-for="tag in tags" class="ml tag">{{ tag }}</span>
                <v-btn
                  fab small color="primary" title="Edit tags"
                  @click="toggleEditTagsMode"
                >
                  <img src="~@/assets/img/pensil-outline.svg" alt="Edit">
                </v-btn>
              </div>
              <div class="text-right" style="flex-grow:1" v-else>
                <Multiselect
                  v-model="editableTags"
                  :multiple="true" :taggable="true"
                  :options="tagsSelectOptions"
                  track-by="name" label="name"
                  @tag="addTag"
                />
                <v-btn
                  small color="primary" class="font-weight-bold"
                  @click="saveTags"
                >SAVE</v-btn>
                <v-btn
                  small color="primary" class="font-weight-bold"
                  @click="toggleEditTagsMode"
                >CANCEL</v-btn>
              </div>
            </li>
          </ul>
        </v-flex>
      </v-layout>
      <div v-if="similarRecords.length" class="record-details-similar">
        <h4>Other videos</h4>
          <transition-group name="fade" tag="div" class="record-details-similar-thumbs">
            <thumbnail
              v-for="record in similarRecords" :key="record.id"
              @click.native.stop.prevent="clickedRecordHandler(record)"
              class="thumbnail clickable center-block"
              :media="record.media"
              :default="record.thumbnail_link"
            ></thumbnail>
          </transition-group>
      </div>
    </v-container>
    </v-item-group>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import RecordPlayer from './RecordPlayer.vue'
import Thumbnail from './Thumbnail.vue'
import RecordRepository from '../../../repositories/RecordRepository.js'
import dates from '../../../services/dates'
import { mapGetters } from 'vuex'
import RecordCut from './RecordCut'
import { getRecordPlayerOptions } from '@/utils'

const round = function (val) {
  return Math.round(val * 100) / 100
}

export default {
  props: ['record', 'markerId'],
  data () {
    return {
      similarRecords: [],
      videoRequestText: '',
      videoRequestLoading: false,
      recordCutEnabled: false,
      cutNotifyInterval: null,
      cutProcessing: false,
      editTagsActive: false,
      editableTags: [],
      tagsSelectOptions: [],
      engines: {
        aws: 'aws', // AWS recognition tags
        kul: 'kul', // KUL recognition tags
        man: 'man', // manual tags
      }
    }
  },
  components: {
    Multiselect,
    RecordPlayer,
    Thumbnail,
    RecordCut,
  },
  mounted () {
    window.addEventListener('keyup', this.keypressed)
    this.updateSimilarRecords()
    this.checkCutState()
    this.tagsSelectOptions = this.record.mltags.map(tag => {
      return { name: tag.category }
    })
  },
  beforeDestroy () {
    window.removeEventListener('keyup', this.keypressed)
    clearInterval(this.cutNotifyInterval)
  },
  watch: {
    record: function () {
      this.similarRecords = []
      this.updateSimilarRecords()
    }
  },
  filters: {
    // round the value to 2 decimal places
    round: round,
    filesize (val) {
      // convert bytes to MBs
      return round(val / 1024 / 1024)
    }
  },
  computed: {
    ...mapGetters(['isLmrConsumer']),
    vod () {
      // find the VOD in media
      return this.record.media && this.record.media.find((media) => {
        return media.name === 'vod'
      })
    },
    original () {
      // find the VOD in media
      return this.record.media && this.record.media.find((media) => {
        return media.name === 'original'
      })
    },
    tags () {
      let manualTags = this.record.mltags
        .filter(tag => tag.engine === this.engines.man)
        .sort((a, b) => a.category <= b.category ? -1 : 1)
        .map((tag) => { return tag.category })

      let tags = this.record.mltags
        .filter(tag => tag.engine !== this.engines.man)
        .sort((a, b) => {
          const accDiff = b.accuracy - a.accuracy
          if (accDiff !== 0) return accDiff
          else return b.frames - a.frames
        }).map((tag) => { return tag.category })
      return manualTags.concat(tags)
    },
    recordDate () {
      return dates.dateFormat(dates.parseDate(this.record.shooting_date))
    },
    recordTime () {
      return dates.timeFormat(dates.parseDate(this.record.shooting_date))
    },
    recordTz () {
      return dates.tzFormat(dates.parseDate(this.record.shooting_date))
    },
    recordCoordinates () {
      const lat = this.record.from_point.coordinates[1]
      const long = this.record.from_point.coordinates[0]
      return `${Math.abs(lat).toFixed(2)}°${lat >= 0 ? 'N' : 'S'}, \
      ${Math.abs(long).toFixed(2)}°${long >= 0 ? 'E' : 'W'}`
    },
    cutCacheUpdateLock () {
      // user should not has possibility to cut record after cut process
      // untill cache will be updated
      const cutProcess = this.record.process_statuses.find(item => {
        return item.process === 'cut'
      })
      return cutProcess && cutProcess.status === 'done' && this.cutProcessing
    }
  },
  methods: {
    getRecordPlayerOptions,
    close () { this.$emit('close') },
    keypressed (event) {
      const esc = 27
      if (event.keyCode === esc) {
        this.close()
      }
    },
    updateSimilarRecords () {
      if (!this.markerId) {
        return
      }
      RecordRepository.fetchSimilarRecords(this.markerId, this.record.id)
      .then((records) => {
        this.similarRecords = records
      })
    },
    clickedRecordHandler (record) {
      this.$emit('clicked-similar-record', record)
    },
    sendVideoRequestPush () {
      this.videoRequestLoading = true
      RecordRepository.requestMoreVideos(this.record.id, this.videoRequestText)
        .then(() => {
          this.videoRequestLoading = false
          this.$store.commit('snackbar/show', {
            message: 'Message have been sent',
            color: 'green',
            timeout: 3000,
          })
        })
        .catch(err => {
          this.videoRequestLoading = false
          this.$store.commit('snackbar/show', {
            message: err.message,
            color: 'red',
            timeout: 3000,
          })
        })
    },
    showRecordCut () {
      this.$refs.playerComponent.player.pause()
      this.recordCutEnabled = true
    },
    showCutSpinner () {
      this.cutProcessing = true
      this.notifyWhenCutFinished()
      setTimeout(() => { this.recordCutEnabled = false }, 3000)
      this.$emit('cut-started', this.record)
      this.close()
    },
    checkCutState () {
      RecordRepository.getRecordCutState(this.record.id).then(resp => {
        // here api will return "busy" while cutting and
        // during 5 minutes after cut have been finished
        // because updating cache takes some time
        if (resp.state === 'busy') {
          this.cutProcessing = true
          this.notifyWhenCutFinished()
        }
      })
    },
    notifyWhenCutFinished () {
      this.cutNotifyInterval = setInterval(() => {
        RecordRepository.getRecordCutState(this.record.id).then(
          resp => {
            if (resp.state === 'free') {
              this.cutProcessing = false
              clearInterval(this.cutNotifyInterval)
            }
          }
        )
      }, 5000)
    },
    toggleEditTagsMode () {
      if (!this.editTagsActive) {
        this.setTagsFromRecord()
        this.editTagsActive = true
      } else {
        this.editTagsActive = false
      }
    },
    setTagsFromRecord () {
      this.editableTags = this.record.mltags
        .map(tag => ({ name: tag.category }))
        .sort((t1, t2) => (t1.name > t2.name) ? 1 : -1)
    },
    addTag (tag) {
      tag = { name: tag.charAt(0).toUpperCase() + tag.slice(1) }
      this.tagsSelectOptions.push(tag)
      this.editableTags.push(tag)
    },
    saveTags () {
      const tags = this.editableTags.map(tag => tag.name)
      this.editTagsActive = false
      RecordRepository.updateRecordTags(this.record.id, tags)
        .then(savedTags => {
          this.$store.commit('snackbar/show', {
            message: 'Tags updated',
            color: 'green',
            timeout: 3000,
          })
          this.$set(this.record, 'mltags', savedTags)
        })
        .catch(err => {
          this.$store.commit('snackbar/show', {
            message: err.message,
            color: 'error',
            timeout: 5000,
          })
        })
    }
  }, // methods
}
</script>

<style lang="sass">
.more-videos-form
  display: flex
  margin-top: 10px
  textarea
    flex-grow: 1
    padding-top: 10px
    margin-right: 10px
    margin-bottom: 15px
    border-bottom: 1px solid #c6c8ca
</style>



// WEBPACK FOOTER //
// RecordDetails.vue?280909bb